<template>
  <div>
    
    <template v-if="display==1">
      <h5>スタッフ管理<span>　<span>{{ staffCount }}</span>件</span></h5>
      <hr>
      <div>
        <a class="btn btn-info col-md-4" href="javascript:void(0);" @click="newStaff"> ＋ 新しいスタッフを登録</a>
      </div>
      <div class="py-3 staff_contents">
        <div v-for="(staff, index) in allGetStaffs">
          <div class="card col-md-12 pl-0 pr-0 m-0 mb-2">
              <div class="card-header">
                  <div class="row">
                      <span class="col-md-8 text-left">{{ staff['last_name'] + ' ' + staff['first_name'] }}</span>
                      <span class="col-md-4 text-right">
                        <a href="javascript:void(0);" @click="editStaff(staff['id'])" class="btn btn-primary btn-sm">編集</a>
                        <a href="javascript:void(0);" @click="deleteStaff(staff['id'])" class="btn btn-secondary btn-sm">削除</a>
                      </span>
                  </div>
              </div>
              <div class="card-body">
                  <div class="row px-3">
                      <div class="col-md-3 pl-1 pr-1 m-0">
                        <img class="" :src="staff['image1']" style="width: 100%;height: auto;">
                      </div>
                      <div class="card col-md-9 pl-0 pr-0 m-0">
                          <div class="card-body">
                              <p class="card-text">登録日:　{{ date_only_format(staff['created_at']) }}</p><!-- YYYY年MM月DD日 -->
                              <p class="card-text">一言アピール:　{{ staff['slogan'] }}</p>
                              <p class="card-text">プロフィール:　{{ staff['profile'] }}</p>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
        </div>
        <div class="page" v-show="staffCount>0">
          <vuejs-paginate
            :page-count="allGetPageCount"
            :page-range="3"
            :margin-pages="2"
            :click-handler="allClickCallback"
            :prev-text="'＜'"
            :next-text="'＞'"
            :container-class="'pagination'"
            :page-class="'page-item'">
          </vuejs-paginate>
        </div>
      </div>
    </template>

    <template v-if="display==2">
      <h5>スタッフを登録</h5>
      <a class="btn btn-info col-md-4" href="javascript:void(0);" @click="backStaff">戻る</a>
      <hr>

      <div class="form-group row mx-0">
          <div class="px-1 col-6">
              <label class="col-sm-6 control-label">姓  <span class="required_mark">必須</span></label>
              <input type="text" placeholder="山本" v-model="staffForm.last_name" class="required form-control" v-bind:class="{ error_input: staffForm.errors.last_name.length > 0 }">
              <div v-if="staffForm.errors.last_name.length > 0">
                <div class="error-text" v-for="(item, index) in staffForm.errors.last_name" :key="index">{{ item }}</div>
              </div>
          </div>
          <div class="px-1 col-6">
              <label class="col-sm-6 control-label">名  <span class="required_mark">必須</span></label>
              <input type="text" placeholder="太郎" v-model="staffForm.first_name" class="required form-control" v-bind:class="{ error_input: staffForm.errors.first_name.length > 0 }">
              <div v-if="staffForm.errors.first_name.length > 0">
                <div class="error-text" v-for="(item, index) in staffForm.errors.first_name" :key="index">{{ item }}</div>
              </div>
          </div>
      </div>

      <div class="form-group row mx-0">
          <div class="px-1 col-6">
              <label class="col-sm-6 control-label">セイ  <span class="required_mark">必須</span></label>
              <input type="text" placeholder="" v-model="staffForm.phonetic_last_name" class="required form-control" v-bind:class="{ error_input: staffForm.errors.phonetic_last_name.length > 0 }">
              <div v-if="staffForm.errors.phonetic_last_name.length > 0">
                <div class="error-text" v-for="(item, index) in staffForm.errors.phonetic_last_name" :key="index">{{ item }}</div>
              </div>
          </div>
          <div class="px-1 col-6">
              <label class="col-sm-6 control-label">メイ  <span class="required_mark">必須</span></label>
              <input type="text" placeholder="" v-model="staffForm.phonetic_first_name" class="required form-control" v-bind:class="{ error_input: staffForm.errors.phonetic_first_name.length > 0 }">
              <div v-if="staffForm.errors.phonetic_first_name.length > 0">
                <div class="error-text" v-for="(item, index) in staffForm.errors.phonetic_first_name" :key="index">{{ item }}</div>
              </div>
          </div>
      </div>

      <div class="form-group">
          <div class="col-sm-12 px-1">
              <label class="col-sm-12 control-label">自己紹介/ キャッチコピー（一行説明）25文字 <span class="required_mark">必須</span></label>
              <textarea placeholder="記入例：　音づくりの職人として、こだわりがあります！" v-model="staffForm.slogan" class="required form-control" rows="1" maxlength="25" v-bind:class="{ error_input: staffForm.errors.slogan.length > 0 }"></textarea>
              <div v-if="staffForm.errors.slogan.length > 0">
                <div class="error-text" v-for="(item, index) in staffForm.errors.slogan" :key="index">{{ item }}</div>
              </div>
          </div>
      </div>

      <div class="form-group">
          <div class="col-sm-12 px-1">
              <label class="col-sm-12 control-label">自己紹介/ プロフィール（説明文）700文字 <span class="required_mark">必須</span></label>
              <textarea placeholder="記入例：

私は当社代表として、当社を引っ張って参りました。スタッフにいつも言っているのはこうです。

「弾きやすく、豊かな音色を奏でるピアノにしよう！」

そのためには、ピアノを修理、調整するスタッフ自身が、ピアノを弾けることがとても大切だと考えています。当社スタッフ全員には、ピアノ演奏をするようずっと勧めてきました。今スタッフでピアノを演奏しない者は一人もおりません。

そのおかげで、仕上がってくるピアノの弾き心地や音色が明らかに以前よりも音楽的に良くなってきています。きちんと寸法通りに仕上げることと音楽的に仕上げることとは、意味と結果が全く違ってきます。スタッフ自身が演奏することで、その違いを肌で理解できるのです。

私たちは、常にピアノの弾き手の側に寄りそうことで、良質かつ音楽的な中古ピアノをお届けしたいと思っています。
" v-model="staffForm.profile" class="required form-control" rows="7" maxlength="700" v-bind:class="{ error_input: staffForm.errors.profile.length > 0 }"></textarea>
              <div v-if="staffForm.errors.profile.length > 0">
                <div class="error-text" v-for="(item, index) in staffForm.errors.profile" :key="index">{{ item }}</div>
              </div>
          </div>
      </div>

      <div class="form-group">
        <div class="col-sm-4 px-1">
            <label for="" class="col-sm-12 control-label">スタッフの画像 推奨サイズ(400px X 400px) <span class="required_mark">必須</span></label>
            <div style="border: solid 1px #bab7b7;border-radius: 4px;min-height: 100px;width: auto;" class="mb-2" v-bind:class="{ error_input: staffForm.errors.image1.length > 0 }">
              <img :src="staffForm.image1" class="my-3">
            </div>
            <label class="col-sm-12 btn btn-warning" @click="uploadImage1">選択</label>
            <input type="file" style="display: none" ref="input1" @change="onImageChange1"/>
            <div v-if="staffForm.errors.image1.length > 0">
              <div class="error-text" v-for="(item, index) in staffForm.errors.image1" :key="index">{{ item }}</div>
            </div>
        </div>
      </div>

      <div class="form-group">
          <div class="b100 col-sm-12">
            <template v-if="mode==1">
              <button type="button" class="bs100 btn btn-primary" @click="staff_form_submit(1)">登録する</button>
            </template>
            <template v-if="mode==2">
              <button type="button" class="bs100 btn btn-primary" @click="staff_form_submit(2)">更新する</button>
            </template>
          </div>
      </div>
    </template>

  </div>
</template>

<script>
import VueJsPaginate from "vuejs-paginate";

export default {
  components: {
    'vuejs-paginate': VueJsPaginate,
  },
  props: { 
    user: Object
  },
  data() {
    return {
      display: 1,
      staffCount: 0,
      imageSet: false,
			all_staffs: [],
			all_parPage: 5,
			all_currentPage: 1,
      isError: false,
      mode: null, // 1:登録 2:更新
      staffForm: {
        errors: {
          last_name: [],
          first_name: [],
          phonetic_last_name: [],
          phonetic_first_name: [],
          slogan: [],
          profile: [],
          image1: [],
        },
        last_name: "",
        first_name: "",
        phonetic_last_name: "",
        phonetic_first_name: "",
        slogan: "",
        profile: "",
        image1: "",
      },
    }
  },
  methods: {
    newStaff() {
      this.display = 2;
      this.imageSet = false;
      this.mode = 1;
      return false;
    },
    backStaff() {
      this.display = 1;
      this.staffFormReset();
      this.get_staffs();
      return false;
    },
    editStaff(id) {
      this.get_staff(id);
      this.display = 2;
      this.imageSet = true;
      this.mode = 2;
      return false;
    },
    deleteStaff(id) {
      if(confirm("本当に削除してもよろしいですか?")) {
        this.staffForm.id = id;
        this.staffForm.delete = 1;
        this.exec_delete_staff();
      }
      return false;
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },
    onImageChange1(e) { this.onImageChange(1, e); },
    onImageChange(target, e) {
      const images = e.target.files || e.dataTransfer.files
      this.getBase64(images[0]).then(image => {
        const originalImg = new Image()
        originalImg.src = image
        originalImg.onload = () => {
          const resizedCanvas = this.createResizedCanvasElement(originalImg)
          const resizedBase64 = resizedCanvas.toDataURL(images[0].type)
          if ( target == 1 ) { this.staffForm.image1 = resizedBase64 }
          this.imageSet = true;
        }
      }).catch(error =>
        alert('画像処理に失敗しました。再度画像を選択してください。')
      )
    },
    uploadImage1() { this.$refs.input1.click(); },
    createResizedCanvasElement(originalImg) {
      const originalImgWidth = originalImg.width
      const orifinalImgHeight = originalImg.height
      const [resizedWidth, resizedHeight] = this.resizeWidthAndHeight(originalImgWidth, orifinalImgHeight)
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')
      canvas.width = resizedWidth
      canvas.height = resizedHeight
      ctx.drawImage(originalImg, 0, 0, resizedWidth, resizedHeight)
      return canvas
    },
    resizeWidthAndHeight(width, height) {
      const MAX_WIDTH = 400
      const MAX_HEIGHT = 400
      if (width > height) {
        if (width > MAX_WIDTH) {
          height *= MAX_WIDTH / width
          width = MAX_WIDTH
        }
      } else {
        if (height > MAX_HEIGHT) {
          width *= MAX_HEIGHT / height
          height = MAX_HEIGHT
        }
      }
      return [width, height]
    },    
    staff_form_submit(btn_type) {
      // this.btn_type = btn_type;
			this.isError = false;
			this.staffForm.errors.last_name = [];
			this.staffForm.errors.first_name = [];
			this.staffForm.errors.phonetic_last_name = [];
			this.staffForm.errors.phonetic_first_name = [];
			this.staffForm.errors.slogan = [];
			this.staffForm.errors.profile = [];
			this.staffForm.errors.image1 = [];
      if (!this.imageSet) {
        this.staffForm.errors.image1.push('画像を選択してください');
        this.isError = true;
      }
      if (!this.staffForm.last_name) {
        this.staffForm.errors.last_name.push('姓が入力されていません');
        this.isError = true;
      }
      if (!this.staffForm.first_name) {
        this.staffForm.errors.first_name.push('名が入力されていません');
        this.isError = true;
      }
      if (!this.staffForm.phonetic_last_name) {
        this.staffForm.errors.phonetic_last_name.push('セイが入力されていません');
        this.isError = true;
      }
      if (!this.staffForm.phonetic_first_name) {
        this.staffForm.errors.phonetic_first_name.push('メイが入力されていません');
        this.isError = true;
      }
      if (!this.staffForm.slogan) {
        this.staffForm.errors.slogan.push('一言アピールが入力されていません');
        this.isError = true;
      }
      if (!this.staffForm.profile) {
        this.staffForm.errors.profile.push('プロフィールが入力されていません');
        this.isError = true;
      }
			if (!this.isError) {
        if ( this.mode == 1 ) {
  				this.exec_new_staff();
        } else if ( this.mode == 2 ) {
  				this.exec_update_staff();
        }
			} else {
				window.scrollTo({
					top: 0,
				});
			}
      return false;
    },
    // 商品登録処理
    async exec_new_staff() {
      this.$store.dispatch('user/new_staff', {
        staff: this.staffForm,
      }).then(res => {
        console.log(res);
        alert('スタッフの登録が完了しました。');
        window.scrollTo({
          top: 0,
        });
        // this.$router.push({path: '/mypage'});
        this.staffFormReset();
        this.backStaff();
      }, error => {
        // バックエンドからエラーが返却された場合、ひとまずアラートでメッセージを出力
        console.log(error.response.data);
        if ('error' in error.response.data) {
          alert(error.response.data['error']);
          window.scrollTo({
            top: 0,
          });
        }
      });
      return false;
    },
    // 商品更新処理
    async exec_update_staff() {
      this.$store.dispatch('user/upd_staff', {
        staff: this.staffForm,
      }).then(res => {
        console.log(res);
        alert('更新が完了しました。');
        window.scrollTo({
          top: 0,
        });
        // this.$router.push({path: '/mypage'});
        this.staffFormReset();
        this.backStaff();
      }, error => {
        // バックエンドからエラーが返却された場合、ひとまずアラートでメッセージを出力
        console.log(error.response.data);
        if ('error' in error.response.data) {
          alert(error.response.data['error']);
          window.scrollTo({
            top: 0,
          });
        }
      });
      return false;
    },
    // スタッフ削除処理
    async exec_delete_staff() {
      this.$store.dispatch('user/delete_staff', {
        staff: this.staffForm,
      }).then(res => {
        console.log(res);
        alert('削除が完了しました。')
        window.scrollTo({
          top: 0,
        });
        // this.$router.push({path: '/mypage'});
        this.staffFormReset();
        this.get_staffs();
      }, error => {
        // バックエンドからエラーが返却された場合、ひとまずアラートでメッセージを出力
        console.log(error.response.data);
        if ('error' in error.response.data) {
          alert(error.response.data['error']);
          window.scrollTo({
            top: 0,
          });
        }
      });
      return false;
    },
		async get_staffs() {
			this.$store.dispatch('user/get_staffs').then(res => {
				console.log(res);
				this.all_staffs = res.data.staffs;
				this.staffCount = this.all_staffs.length;
			}, error => {
				console.log('error発生');
				console.log(error);
				this.$nextTick(() => {
          window.scrollTo({
            top: 0,
          });
				});
			});
		},
		async get_staff(id) {
			this.$store.dispatch('user/get_staff', {
        id: id,
      }).then(res => {
				console.log(res);
				let g_staff = res.data.staff;
        this.staffForm.image1 = g_staff.image1;
        this.staffForm.last_name = g_staff.last_name;
        this.staffForm.first_name = g_staff.first_name;
        this.staffForm.phonetic_last_name = g_staff.phonetic_last_name;
        this.staffForm.phonetic_first_name = g_staff.phonetic_first_name;
        this.staffForm.slogan = g_staff.slogan;
        this.staffForm.profile = g_staff.profile;
        this.staffForm.id = g_staff.id;
			}, error => {
				console.log('error発生');
				console.log(error);
				this.$nextTick(() => {
          window.scrollTo({
            top: 0,
          });
				});
			});
		},
		allClickCallback: function (pageNum) {
      this.all_currentPage = Number(pageNum);
			this.$nextTick(() => {
				window.scrollTo({
					top: 0,
				});
			});
    },
    staffFormReset: function () {
      this.staffForm.image1 = "";
      this.staffForm.last_name = "";
      this.staffForm.first_name = "";
      this.staffForm.phonetic_last_name = "";
      this.staffForm.phonetic_first_name = "";
      this.staffForm.slogan = "";
      this.staffForm.profile = "";
    },
  },
	computed: {
		allGetStaffs: function() {
			let current = this.all_currentPage * this.all_parPage;
			let start = current - this.all_parPage;
			return this.all_staffs.slice(start, current);
		},
		allGetPageCount: function() {
			return Math.ceil(this.all_staffs.length / this.all_parPage);
		},
	},
  created() {
    this.get_staffs();
  },

}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/mypage/seller/staff.vue